import { FC } from 'react';

import SequentialLoadingBars from './shared/SequentialLoadingBars';
import { useReadiness } from '@components/quiz/ReadinessProvider';
import { useSquadPortraits } from '@components/quiz/ReadinessProvider/utils/useSquadPortraits';
import type { SanityReadinessProcessingBlock } from '@lib/sanity/types';

type ProcessingBlockProps = SanityReadinessProcessingBlock & {
  onComplete: () => void;
};

/**
 * Step 8: processing. Sequential loading bars (Sanity-editable labels and
 * durations); auto-advances to the verdict when the last bar completes.
 * Warms the squad portrait cache here so the verdict pitch renders without a
 * fetch flash.
 */
const ProcessingBlock: FC<ProcessingBlockProps> = ({
  loadingSteps,
  onComplete
}) => {
  const { state } = useReadiness();
  useSquadPortraits(state.team);

  return (
    <section className="flex items-start justify-center px-6 py-16">
      <div className="w-full max-w-sm">
        <SequentialLoadingBars
          steps={loadingSteps ?? []}
          onComplete={onComplete}
        />
      </div>
    </section>
  );
};

export default ProcessingBlock;
